import ProjectCollectionModel from "../../../core/model2/project-collection/project-collection-model";
import CustomView from "../../../core/model2/custom-view/custom-view";
import {NavigationSectionType} from "../../../core/model2/navigation/@const";


export default function mainMenu_projectViews():CustomView[] | ProjectCollectionModel[] {

    const customViews = _.filter(gd.session.customViews.models, (view)=>{
        return view.location===NavigationSectionType.PROJECTS
    }) as CustomView[]

    const portfolioViews = _.filter(gd.session.projectCollections.modelsNotInStructure, (portfolio)=>{
        return portfolio.location===NavigationSectionType.PROJECTS
    }) as ProjectCollectionModel[]

    // @ts-ignore
    return [...customViews, ...portfolioViews]

}
